import React, { useState } from 'react'
import TabComponent from '../Global/Tabs/Tab'
import { Explore } from './Explore Investment/Explore'
import MaturedInvestment from './Matured/MaturedInvestment'
import { Wrap } from 'src/components/Investment/Matured/maturedStyle'
import { Myinvestment } from './MyInvestment/Myinvestment'

const tabs = [
  {
    name: 'Now Selling',
    key: 'all',
    component: <Explore />,
  },
  {
    name: 'Ongoing',
    key: 'ongoing',
    component: <Myinvestment />,
  },
  {
    name: 'Matured',
    key: 'matured',
    component: <MaturedInvestment />,
  },
]

const InvestmentToggle = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].key)

  return (
    <Wrap>
      <TabComponent
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      <div className={'content active-content'}>
        {tabs.map((tab) => {
          return tab.key === activeTab ? tab.component : null
        })}
      </div>
    </Wrap>
  )
}

export { InvestmentToggle }
